import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SubPurchaseOrderService, GetSubPurchaseOrdersQueryParams } from "src/services/purchaseOrders";

const useSubPurchaseOrders = (
  subPurchaseOrderService: SubPurchaseOrderService,
  queryParams: GetSubPurchaseOrdersQueryParams
) => {
  const queryClient = useQueryClient();

  const {
    data: paginatedSubPurchaseOrders,
    error: fetchError,
    isLoading
  } = useQuery({
    queryKey: ["subPurchaseOrders", queryParams],
    queryFn: () => subPurchaseOrderService.getSubPurchaseOrders(queryParams)
  });

  const refreshSubPurchaseOrders = () => {
    queryClient.removeQueries({ queryKey: ["subPurchaseOrders"], exact: false });
  };

  return { paginatedSubPurchaseOrders, fetchError, isLoading, refreshSubPurchaseOrders };
};

export { useSubPurchaseOrders };
